export default "__VITE_ASSET__CiwMRyw3__"